export default [
    // {
    //     name: 'environmentMapTexture',
    //     type: 'cubeTexture',
    //     path:
    //     [
    //         'textures/environmentMap/px.jpg',
    //         'textures/environmentMap/nx.jpg',
    //         'textures/environmentMap/py.jpg',
    //         'textures/environmentMap/ny.jpg',
    //         'textures/environmentMap/pz.jpg',
    //         'textures/environmentMap/nz.jpg'
    //     ]
    // },
    // {
    //     name: 'grassColorTexture',
    //     type: 'texture',
    //     path: 'textures/dirt/color.jpg'
    // },
    // {
    //     name: 'grassNormalTexture',
    //     type: 'texture',
    //     path: 'textures/dirt/normal.jpg'
    // },
    // {
    //     name: 'matcap1',
    //     type: 'texture',
    //     path: 'textures/matcaps/4.png'
    // },
    {
        name: 'particles',
        type: 'texture',
        path: 'textures/particles/1.png'
    },
    {
        name: 'globe',
        type: 'gltfModel',
        path: 'models/NoHochiGlobe.glb'
    },
    // {
    //     name: 'doge',
    //     type: 'gltfModel',
    //     path: 'models/doge.glb'
    // },
    {
        name: 'mainFont',
        type: 'font',
        path: 'fonts/unibody.json'
    },
    // {
    //     name: 'uiFont',
    //     type: 'font',
    //     path: 'fonts/roboto.json'
    // },
    // {
    //     name: 'uiTexture',
    //     type: 'texture',
    //     path: 'fonts/roboto.png'
    // },
    // {
    //     name: 'uiFont',
    //     type: 'font',
    //     path: 'fonts/unibody-msdf.json'
    // },
    // {
    //     name: 'uiTexture',
    //     type: 'texture',
    //     path: 'fonts/unibody.webp'
    // },
    // {
    //     name: 'neonTexture',
    //     type: 'texture',
    //     path: 'images/neon.jpg'
    // },
    // {
    //     name: 'ctGif',
    //     type: 'texture',
    //     path: 'images/ct.gif'
    // },
    {
        name: 'uralaLogo',
        type: 'svg',
        path: 'images/urala-int.svg'
    },
    {
        name: 'ctLogo',
        type: 'svg',
        path: 'images/ctb.svg'
    },
    {
        name: 'aboutJP',
        type: 'svg',
        path: 'images/about.svg'
    },
    {
        name: 'locationsJP',
        type: 'svg',
        path: 'images/locations.svg'
    },
    {
        name: 'contactJP',
        type: 'svg',
        path: 'images/contact.svg'
    },
    {
        name: 'workJP',
        type: 'svg',
        path: 'images/work.svg'
    },
    // {
    //     name: 'maskPanel',
    //     type: 'svg',
    //     path: 'images/maskPanel.svg'
    // },
    // {
    //     name: 'aboitz',
    //     type: 'texture',
    //     path: 'images/work/aboitz.webp'
    // },
    // {
    //     name: 'kaplan',
    //     type: 'texture',
    //     path: 'images/work/kaplan.webp'
    // },
    // {
    //     name: 'spotify',
    //     type: 'texture',
    //     path: 'images/work/spotify.webp'
    // },
    // {
    //     name: 'lawork',
    //     type: 'texture',
    //     path: 'images/work/lawork.webp'
    // },
    // {
    //     name: 'coint',
    //     type: 'texture',
    //     path: 'images/work/coint.webp'
    // },
    // {
    //     name: 'loreal',
    //     type: 'texture',
    //     path: 'images/work/loreal.webp'
    // },
    // {
    //     name: 'amos',
    //     type: 'texture',
    //     path: 'images/work/amos.webp'
    // },
    // {
    //     name: 'kohler',
    //     type: 'texture',
    //     path: 'images/work/kohler.webp'
    // },
]